import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Subscription, timer} from "rxjs";

import {PushInfo} from "../../services/fcm/fcm.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";

// 알림 팝업이 자동으로 닫힐때까지 대기하는 시간.
const AUTO_CLOSE_DELAY = 10000;

@Component({
  selector: 'app-noti-popup',
  templateUrl: './noti-popup.component.html',
  styleUrls: ['./noti-popup.component.scss']
})
export class NotiPopupComponent implements OnInit, OnDestroy {
  @Input() pushInfo: PushInfo;
  //  = {
  //   title: '듣고 배우는 한국어에 대하여',
  //   body: '한국어를 사용하는 모든 사람들이 한국어를 정확하게 사용할 수 있도록 도와서 사고능력을 높이고 언어의 가장 중요한 목적인 정확한 의사소통이 가능하도록 하여 언어 소통이 만드는 사회의 보이지 않는 제반의 문제까지도 해결할 수 있도록 돕는다.',
  //   page: '/board/1?id=1',
  // };

  private autoClose$: Subscription = null;

  constructor(
    private router: Router,
    private globalEventSvc: GlobalEventService,
    private lm: LayoutMgrService,
  ) {
  }

  ngOnInit(): void {
    this.autoClose$ = timer(AUTO_CLOSE_DELAY).subscribe(() => this.lm.CloseNotiPopup());
  }

  ngOnDestroy(): void {
    if (this.autoClose$) {
      this.autoClose$.unsubscribe();
      this.autoClose$ = null;
    }
  }

  onGotoDetail($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event);

    if (this.pushInfo?.page) {
      this.lm.CloseNotiPopup();
      this.router.navigateByUrl(this.pushInfo.page).then()
        .catch(error => console.error(error));
    }
  }

  onClickClose($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event);

    this.lm.CloseNotiPopup();
  }
}
